// scrollPatch.js
const resetScroll = () => {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const browserHistory = window.history;

const originalPushState = browserHistory.pushState.bind(browserHistory);
browserHistory.pushState = function (...args) {
  resetScroll();
  return originalPushState(...args);
};

const originalReplaceState = browserHistory.replaceState.bind(browserHistory);
browserHistory.replaceState = function (...args) {
  resetScroll();
  return originalReplaceState(...args);
};

window.addEventListener('popstate', resetScroll);

if ('scrollRestoration' in browserHistory) {
  browserHistory.scrollRestoration = 'manual';
}